import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button, Grid, Typography } from '@material-ui/core';

import { S3Object, UserProfileInput } from 'api';
import { AspectRatios } from 'types/app';
import { IUploader, UploadDialog, Uploader, UploadInput, UserAvatar } from 'components';

const ProfileImage: FC = () => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext<UserProfileInput>();

  function handleSave(image: S3Object) {
    setFieldValue('image', image);
  }

  return (
    <Fragment>
      <Grid container>
        <Grid item xs={3}>
          <Typography variant="h6">{t('user:profileImage')}</Typography>
        </Grid>
        <Grid item xs>
          <Uploader onSave={handleSave} data-testid="uploader">
            {(uploaderProps: IUploader) => (
              <Fragment>
                <Grid container spacing={4} wrap="nowrap">
                  <Grid item>
                    <UploadInput onUpload={uploaderProps.onUpload}>
                      <UserAvatar data-testid="profile_image_avatar" user={values} size={100} />
                    </UploadInput>
                  </Grid>
                  <Grid item container alignItems="center">
                    <UploadInput onUpload={uploaderProps.onUpload}>
                      <Button component="span" variant="outlined" fullWidth>
                        {t('user:changeImage')}
                      </Button>
                    </UploadInput>
                  </Grid>
                </Grid>
                <UploadDialog
                  i18nKeyTitle="user:yourProfileImage"
                  i18nKeyReplace="components:replaceImage"
                  aspectRatio={AspectRatios.square}
                  {...uploaderProps}
                />
              </Fragment>
            )}
          </Uploader>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ProfileImage;
